import React from 'react';
import { ReactSVG } from 'react-svg';
import chevron from '@/widget/ui/images/chevron-right.svg';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import useConversationHeader from '@/widget/ui/hooks/useConversationHeader';
import cx from 'classnames';
import styles from './Header.module.scss';
import OperatorsList from '../../shared/OperatorsList';

function Header() {
  const { settings } = useChatWidgetContext();
  const {
    isMobile, host, color: backgroundColor, textColor: color,
  } = settings;
  const {
    returnFromConversation,
    currentOperators,
    onlineOperators,
  } = useConversationHeader();

  return (
    <div style={{ backgroundColor, color }} className={cx(styles.container, { [styles.mobile]: isMobile })}>
      <div
        className={styles.backButton}
        onClick={returnFromConversation}
      >
        <ReactSVG src={host + chevron} />
      </div>
      <div className={styles.content}>
        <div className={styles.operatorsContainer}>
          {!!currentOperators.length && <OperatorsList operatorsList={currentOperators} />}
          {!currentOperators.length && !!onlineOperators.length && <OperatorsList />}
        </div>
        <div className={styles.caption}>
          <div className={styles.header}>
            {!currentOperators.length && !onlineOperators.length && window.ChatWidget.i18n.t('chat_widget.conversation_caption.offline')}
            {(!!currentOperators.length || !!onlineOperators.length) && window.ChatWidget.i18n.t('chat_widget.conversation_caption.online')}
          </div>
          <div className={styles.status}>
            {!!currentOperators.length && (
              window.ChatWidget.i18n.t('chat_widget.conversation_caption.responsible', { count: currentOperators.length })
            )}
            {!currentOperators.length && !!onlineOperators.length && (
              window.ChatWidget.i18n.t('chat_widget.conversation_caption.operators', { count: onlineOperators.length })
            )}
            {!currentOperators.length && !onlineOperators.length && (
              window.ChatWidget.i18n.t('chat_widget.conversation_caption.offlineMessage')
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
